import styled from "styled-components";

/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : Estilos RegisterPage
Description : Se definene los estilos de los componentes de la vista del formulario de registro
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se defienen estilos y elementos de la vista de registro.
================================================================================ */

export const DivRow = styled.div`
    display: flex;
`;
export const Div = styled.div`
    margin: auto;
    width: 100%;
    height: 100%;
    @media screen and (max-width: 960px){
        align-content: center;
    }
`;
export const Form = styled.div`
    width: 25%;
    box-shadow: 2px 5px 15px #999;
    @media screen and (max-width: 960px){
        justify-content: center;
        box-shadow: none;
    }
`;

export const DivImg = styled.div`
    width: 75%;
    padding-right: 50px;
    @media screen and (max-width: 960px){
        display: none;
    }
`;

export const Img = styled.img`
    width: 100%;
    padding-top: 80px;
    float: left;
    @media screen and (max-width: 960px){
        display: none;
    }
`;